import { requestData } from "@/api/api-config";

export const STAFF_PIN_PATTERN = /^\d{4}$/;

export interface StaffPinVerification {
  valid: boolean;
  /** Too many wrong guesses in a row; the server refuses checks until the lock expires. */
  locked: boolean;
  attemptsRemaining: number;
}

/** Set or replace the signed-in staff member's device PIN (exactly 4 digits).
 *  Resolves false on any failure rather than throwing. */
export async function setMyStaffPin(pin: string): Promise<boolean> {
  try {
    const result = await requestData<boolean>(
      "user/me/pin",
      "put",
      { json: { pin } },
      false,
    );
    return result === true;
  } catch {
    return false;
  }
}

/** Check a PIN against the signed-in staff member's stored one. Resolves null
 *  when the request itself failed, so callers can tell "wrong PIN" from "no answer". */
export async function verifyMyStaffPin(
  pin: string,
): Promise<StaffPinVerification | null> {
  try {
    const result = await requestData<StaffPinVerification>(
      "user/me/pin/verify",
      "post",
      { json: { pin } },
      false,
    );
    return result ?? null;
  } catch {
    return null;
  }
}
